export default __webpack_public_path__ + "static/media/travis.60b51bb7.jpg";